import React, { useEffect, useState } from 'react';
import {
	Container,
	Grid, Stepper, Step, StepLabel, Button, Typography, CircularProgress, Backdrop, Box,
	useTheme,
	useMediaQuery
} from '@mui/material';
import { Formik, Form } from 'formik';
import ResourceForm from '../components/Debit/MainPage/Forms/ResourceForm';
import PersonDataForm from '../components/Debit/MainPage/Forms/PersonDataForm';
import CardDataForm from '../components/Debit/MainPage/Forms/CardDataForm';
import ReviewData from '../components/Debit/MainPage/ReviewData/ReviewData';
// import CheckoutSuccess from '../components/Debit/MainPage/CheckoutSuccess';
import ResourceDetailsForm from '../components/Debit/MainPage/Forms/ResourceDetailsForm';
import validationSchema from '../components/Debit/MainPage/FormModel/validationSchema';
import formInitialValues from '../components/Debit/MainPage/FormModel/formInitialValues';
import checkoutFormModel from '../components/Debit/MainPage/FormModel/checkoutFormModel';
// import useStyles from '../components/Debit/MainPage/style';
import Page from '../components/Page';
import useWindowDimensions from '../components/Debit/Utils/Hooks/useWindowDimensions';
import { useNavigate } from 'react-router-dom';

let steps = ['Selección Recurso', 'Detalle Recurso', 'Datos Personales', 'Medio de pago', 'Revisar Datos'];
const { formId, formField } = checkoutFormModel;

export default function MediosPagos() {

	const theme = useTheme();
	const navigate = useNavigate();

	const desktop = useMediaQuery(theme.breakpoints.up('md'));

	const classes = {
		stepper: {
			padding: '3px'
		},
		buttons: {
			display: 'flex',
			justifyContent: 'flex-end'
		},
		button: {
			marginTop: '3px',
			marginLeft: '3px',
			color: 'white'
		},
		wrapper: {
			margin: '3px',
			position: 'relative'
		},
		buttonProgress: {
			position: 'absolute',
			top: '50%',
			left: '50%'
		},
		backdrop: {
			zIndex: '1',
			color: '#fff'
		}
	};
	const [activeStep, setActiveStep] = useState(0);
	const currentValidationSchema = validationSchema[activeStep];
	const isLastStep = activeStep === steps.length - 1;
	const { width } = useWindowDimensions();
	const [successMessage, setSuccessMessage] = useState("");
	const [formSuccess, setFormSuccess] = useState(false);

	const errorAlert = (message) => {
		return {
			title: 'Ups!',
			text: message,
			icon: 'error',
			confirmButtonText: 'Aceptar'
		}
	}

	async function submitForm(values, actions) {
		try {
			const options = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(values)
			};

			let res = await fetch(`${import.meta.env.VITE_API_URL}/debit/form`, options);
			res = await res.json();

			// if (res.ok == true) {
			//   setSuccessMessage(res[0].message)
			// } else {
			//   setSuccessMessage('Ocurrió un error al adherirse a débito automático. Intente más tarde')
			// }

			if (res.ok == true) {
				setSuccessMessage(res[0]?.message || "Usted ha sido adherido correctamente al débito automático.");
				setFormSuccess(true);
				setTimeout(() => {
					navigate('/debito-automatico');
				}, 3000);
			} else {
				setSuccessMessage("Ocurrió un error al adherirse a débito automático. Intente más tarde.");
				setFormSuccess(false);
			}

			setActiveStep(activeStep + 1);

		} catch (e) {
			errorAlert(e);
		}
		actions.setSubmitting(false);
	}

	async function handleSubmit(values, actions) {
		if (isLastStep) {
			submitForm(values, actions);
		}
		else {
			setActiveStep(activeStep + 1);
			actions.setTouched({});
			actions.setSubmitting(false);
		}
	}

	function handleBack() {
		setActiveStep(activeStep - 1);
	}

	useEffect(() => {
	}, [activeStep])
	return (

		<Page>
			<Container>
				<Grid
					container
					padding={'1.875rem'}
					justifyContent="center"
					direction="column"
				>
					<Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography variant="h5" gutterBottom sx={{
							fontWeight: 600,
							color: '#36B7E8',
							margin: '0px'
						}}>
							Debito Automático
						</Typography>
					</Grid>
					<Typography variant="h6" gutterBottom sx={{
						fontWeight: 400,
						fontSize: '1rem'
					}}>
						Agregar medio de pago
					</Typography>
					{width >= 425 &&
						<Box my={3}>
							<Stepper activeStep={activeStep} sx={classes.stepper} alternativeLabel>
								{steps.map(label =>
									<Step key={label}>
										<StepLabel>{label}</StepLabel>
									</Step>
								)}
							</Stepper>
						</Box>
					}
					<Box>

						{activeStep === steps.length ?
							<Box>
								<Typography variant="h5" gutterBottom>
									<Box textAlign="center" m={4}>
										{formSuccess
											? "Se procesó la solicitud de manera exitosa!"
											: "Ocurrió un error al procesar su solicitud"}
									</Box>
								</Typography>
								<Typography variant="subtitle1" gutterBottom>
									<Box textAlign="center" m={4}>
										{successMessage}
									</Box>
								</Typography>
							</Box>
							:
							<Formik
								initialValues={formInitialValues}
								validationSchema={currentValidationSchema}
								onSubmit={handleSubmit}
							>
								{({ isSubmitting }) => (
									<Form id={formId}>
										{renderStepContent(activeStep)}
										<Box sx={classes.buttons}>
											{(activeStep !== 0 && !isSubmitting) &&
												<Button onClick={handleBack} sx={classes.button} disableFocusRipple>
													Volver
												</Button>
											}
											{activeStep !== 0 &&
												<Box sx={classes.wrapper}>
													<Button
														disabled={isSubmitting}
														type="submit"
														variant="contained"
														sx={classes.button}
														disableFocusRipple
													>
														{isLastStep ? 'Inscribir' : 'Siguiente'}
													</Button>
												</Box>
											}
											<Backdrop sx={classes.backdrop} open={isSubmitting}>
												<CircularProgress color="primary" />
											</Backdrop>
										</Box>
									</Form>
								)}
							</Formik>
						}
					</Box>
				</Grid>
			</Container>
		</Page>

	);
}

function renderStepContent(step) {
	switch (step) {
		case 0:
			return <ResourceForm formField={formField} />;
		case 1:
			return <ResourceDetailsForm formField={formField} />;
		case 2:
			return <PersonDataForm formField={formField} />;
		case 3:
			return <CardDataForm formField={formField} />;
		case 4:
			return <ReviewData />;
		default:
			return <div>Not Found</div>;
	}
}